"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Hashtable = /** @class */ (function () {
    function Hashtable() {
        this._map = new Map();
        this._pointer = 0;
    }
    Object.defineProperty(Hashtable.prototype, "length", {
        get: function () {
            return this._map.size;
        },
        enumerable: false,
        configurable: true
    });
    Hashtable.prototype.next = function () {
        if (this._pointer < this._map.size) {
            return {
                done: false,
                value: this._map[this._pointer++]
            };
        }
        else {
            return {
                done: true,
                value: null
            };
        }
    };
    Hashtable.prototype.toJSON = function () {
        var obj = Object.create(null);
        this._map.forEach(function (value, key) {
            if (typeof value == 'string' && value.startsWith("'") && value.endsWith("'"))
                obj[key] = value.substr(1, value.length - 2);
            else
                obj[key] = value;
        });
        return obj;
    };
    Hashtable.prototype.values = function () {
        return Array.from(this._map.values());
    };
    Hashtable.prototype.keys = function () {
        return Array.from(this._map.keys());
    };
    Hashtable.prototype.entrySet = function () {
        return Array.from(this._map.entries());
    };
    Object.defineProperty(Hashtable.prototype, "entries", {
        get: function () {
            return this._map;
        },
        enumerable: false,
        configurable: true
    });
    Hashtable.prototype.isEmpty = function () {
        return this._map.size === 0;
    };
    Hashtable.prototype.containsKey = function (key) {
        return this._map.has(key);
    };
    Hashtable.prototype.get = function (key) {
        return this._map.get(key);
    };
    Hashtable.prototype.delete = function (key) {
        return this._map.delete(key);
    };
    Hashtable.prototype.put = function (key, value) {
        if (value === null && this._map.has(key))
            this._map.delete(key);
        else
            this._map.set(key, value);
    };
    Hashtable.prototype.clear = function () {
        this._map.clear();
    };
    Hashtable.prototype.toObject = function () {
        var obj = {};
        this._map.forEach(function (value, key) { return (obj[key] = value); });
        return obj;
    };
    Hashtable.prototype[Symbol.iterator] = function () {
        return this._map.entries();
    };
    return Hashtable;
}());
exports.default = Hashtable;

//# sourceMappingURL=Hashtable.js.map
